import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!, $goodId: Int!, $input: AdminCustomDealerGoodInput!) {\n    adminCustomDealerGoodInfo(\n      dealerId: $dealerId,\n      goodId: $goodId,\n      input: $input\n    ) {\n      dealerId\n      details\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation($goodId: Int!, $input: EditGoodInput!) {\n    updateGood(\n      input: $input\n      goodId: $goodId\n    ) {\n      author\n      createdAt\n      coverImages\n      details\n      id\n      isbn\n      managers {\n        createdBy {\n          id\n          username\n        }\n        modifiedBy {\n          id\n          username\n        }\n      }\n      press\n      price\n      publishedDate\n      status\n      subTitle\n      thumb\n      title\n      updatedAt\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($input: NewGoodInput!) {\n    createGood(\n      input: $input\n    ) {\n      author\n      coverImages\n      createdAt\n      details\n      id\n      isbn\n      managers {\n        createdBy {\n          id\n          username\n        }\n        modifiedBy {\n          id\n          username\n        }\n      }\n      press\n      price\n      publishedDate\n      status\n      subTitle\n      thumb\n      title\n      updatedAt\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!, $goodId: Int!, $input: DealerCustomGoodInput!) {\n    customDealerGoodInfo(\n      dealerId: $dealerId,\n      goodId: $goodId,\n      input: $input\n    ) {\n      details\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var customDealerGoodInfo = gql(_templateObject());
export var createGood = gql(_templateObject2());
export var updateGood = gql(_templateObject3());
export var adminCustomDealerGoodInfo = gql(_templateObject4());